import messages, {
  NAME_PLACEHOLDER,
  ORIGIN_PLACEHOLDER,
  TARGET_PLACEHOLDER,
  COUNT_PLACEHOLDER,
} from "messages";
import type { SelectedItem } from "../..";

export default function getMovedMessage({
  selected,
  originFolder,
  targetFolder,
  success,
}: {
  selected: Pick<SelectedItem, "name">[];
  originFolder?: { name: string };
  targetFolder?: { name: string };
  success: boolean;
}) {
  if (!success) {
    return messages.oops;
  }
  return selected.length === 1
    ? messages.hasBeenMovedFrom
        .replace(NAME_PLACEHOLDER, selected[0].name)
        .replace(ORIGIN_PLACEHOLDER, originFolder?.name || messages.attachments)
        .replace(TARGET_PLACEHOLDER, targetFolder?.name || messages.attachments)
    : messages.haveBeenMovedFrom
        .replace(COUNT_PLACEHOLDER, `${selected.length}`)
        .replace(ORIGIN_PLACEHOLDER, originFolder?.name || messages.attachments)
        .replace(
          TARGET_PLACEHOLDER,
          targetFolder?.name || messages.attachments,
        );
}
